// src/pages/admin/CustomerLeadsPage.js
import React from "react";

const CustomerLeadsPage = () => {
  return (
    <main className="flex-1 p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">
        Customer & Leads Management
      </h1>
      <p className="text-gray-600 mb-6">
        View, manage, and engage with your customer data and leads.
      </p>

      {/* Placeholder for table and filters */}
      <div className="bg-white p-6 rounded-xl shadow">
        <p className="text-sm text-gray-500">
          🔍 Table of customers and leads will appear here.
        </p>
      </div>
    </main>
  );
};

export default CustomerLeadsPage;
